import styled from "styled-components"
import { Link } from "react-router-dom"

const StyledButton = styled(Link)`
  margin: 0;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  background-color: var(--green);
  color: white;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 1rem;
`

const DonateButton = () => {
  return (
    <StyledButton to="/donate">
      Donate Now
    </StyledButton>
  )
}

export default DonateButton